export default __webpack_public_path__ + "img/file-pdf.febc0db5.svg";